var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.4992,2 L16.5665625,2 L16.5665625,4.76139747 C16.5665625,5.66454684 15.8746875,6.38683544 15.006,6.38683544 L14.514,6.38683544 C13.6453125,6.38683544 12.9534375,5.66493165 12.9534375,4.76139747 L12.9534375,2 L7.0340625,2 L7.0340625,4.76139747 C7.0340625,5.66454684 6.32911875,6.38683544 5.4612,6.38683544 L4.9692,6.38683544 C4.10128125,6.38683544 3.3825,5.66493165 3.3825,4.76139747 L3.3825,2 L1.1808,2 C0.53120625,2 0,2.56759494 0,3.24332152 L0,19.0113013 C0,19.6870278 0.53120625,20.24 1.1808,20.24 L18.4992,20.24 C19.1487937,20.24 19.68,19.6870278 19.68,19.0113013 L19.68,3.24332152 C19.68,2.56759494 19.1487937,2 18.4992,2 Z M18.0271875,17.6810127 C18.0257103,18.1585795 17.6393705,18.5453566 17.1623438,18.5468354 L2.51765625,18.5468354 C2.04062945,18.5453566 1.6542897,18.1585795 1.6528125,17.6810127 L1.6528125,8.83037975 C1.6542897,8.35281294 2.04062945,7.96603583 2.51765625,7.96455696 L17.1623438,7.96455696 C17.6393705,7.96603583 18.0257103,8.35281294 18.0271875,8.83037975 L18.0271875,17.6810127 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75758644,5.28 C4.34429831,5.28 4,4.84656716 4,4.32526567 L4,0.943701493 C4,0.42318806 4.34429831,0 4.75758644,0 L5.17412881,0 C5.58741695,0 5.92,0.42318806 5.92,0.943701493 L5.92,4.32487164 C5.92,4.84656716 5.58741695,5.28 5.17412881,5.28 L4.75758644,5.28 Z M14.1460327,5.28 C13.7256189,5.28 13.3978947,4.84656716 13.3978947,4.32487164 L13.3978947,0.943307463 C13.3978947,0.42318806 13.7256189,0 14.1460327,0 L14.5697568,0 C14.9901706,0 15.3178947,0.42318806 15.3178947,0.943307463 L15.3178947,4.32487164 C15.3178947,4.84656716 14.9901706,5.28 14.5697568,5.28 L14.1460327,5.28 Z M2.76,9.04 L6.12,9.04 L6.12,12.04 L2.76,12.04 L2.76,9.04 Z M2.76,13.24 L6.12,13.24 L6.12,16.24 L2.76,16.24 L2.76,13.24 Z M7.64727273,9.04 L11.0072727,9.04 L11.0072727,12.04 L7.64727273,12.04 L7.64727273,9.04 Z M7.64727273,13.24 L11.0072727,13.24 L11.0072727,16.24 L7.64727273,16.24 L7.64727273,13.24 Z M12.84,9.04 L16.2,9.04 L16.2,12.04 L12.84,12.04 L12.84,9.04 Z M12.84,13.24 L16.2,13.24 L16.2,16.24 L12.84,16.24 L12.84,13.24 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8ef338a8e22882b06f5ddebd9df77b57.svg";
export { ForwardRef as ReactComponent };